import React from 'react';
import ChatsContextType from '../types/ChatsContextType';

const ChatsContext = React.createContext<ChatsContextType>({ chats: [], sendChatMessage: () => {} });

export default ChatsContext;